export default "__VITE_ASSET__wnU9DbAu__"